import { Image, Typography, theme } from "antd";

const { Text } = Typography;

interface ImageBlockProps {
	src: string;
	alt: string;
	caption?: string;
}

export default function ImageBlock({ src, alt, caption }: ImageBlockProps) {
	const { token } = theme.useToken();

	return (
		<figure style={{ margin: "16px 0", textAlign: "center" }}>
			<Image
				src={src}
				alt={alt}
				style={{
					maxWidth: "100%",
					borderRadius: token.borderRadiusLG,
					border: `1px solid ${token.colorBorderSecondary}`,
				}}
			/>
			{caption && (
				<figcaption style={{ marginTop: 8 }}>
					<Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
						{caption}
					</Text>
				</figcaption>
			)}
		</figure>
	);
}
